
  import type { PropType } from 'vue';
  import { defineComponent } from 'vue';

  import IconComponent from '@/common/ui/IconComponent.vue';
  import { isAbsoluteUrl } from '@/common/utils/url';

  import { TTableTreeData } from '../types/tableTypes';
  import { TPaginationConfig, TTableColumnConfig, TTableData, TTableWithOuterFilterConfig } from '../types/tableTypes';

  type TTableProps = {
    columns: TTableColumnConfig<TTableData>[];
    params: TTableWithOuterFilterConfig['params'];
    pagination?: TPaginationConfig;
  };

  export default defineComponent({
    name: 'TableTreeRow',
    components: {
      IconComponent,
    },
    emits: ['toggleExpanded'],
    props: {
      columns: {
        type: Array as PropType<TTableProps['columns']>,
        required: true,
      },
      item: {
        type: Object as PropType<TTableData>,
        required: true,
      },
      expandedItems: {
        type: Object as () => Set<string>,
        required: true,
      },
      isHasChildren: {
        type: Boolean,
        required: true,
      },
    },
    computed: {
      isExpanded() {
        return this.expandedItems.has(this.item._key);
      },
    },
    methods: {
      getRenderComponentProps(column: TTableColumnConfig<TTableTreeData>, item: TTableTreeData, index: number) {
        if (!column.renderComponent) return {};

        if (column.renderComponent.props) {
          return column.renderComponent.props(item, index);
        }

        return {
          ...(typeof item[column.field] === 'object' && item[column.field] !== null
            ? (item[column.field] as Record<string, unknown>)
            : {}),
        };
      },

      isAbsoluteUrl(link: string) {
        return isAbsoluteUrl(link);
      },
    },
  });
